import React from "react";
import styled from "styled-components";
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  display,
  PositionProps,
  DisplayProps,
  position,
} from "styled-system";

interface StyledProps
  extends SpaceProps,
    LayoutProps,
    PositionProps,
    DisplayProps {
  fill?: string;
  children?: React.ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
  ${position}
`;

const GavelLightSVG: React.FunctionComponent<StyledProps> = ({
  fill = "black",
  ...props
}) => {
  return (
    <StyledContainer {...props}>
      <svg
        aria-hidden="true"
        focusable="false"
        data-icon="gavel"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="100%"
        height="100%"
      >
        <title>Gavel Light Icon</title>
        <path
          fill={fill}
          d="M497.965 176.618l-23.185-23.185c-13.611-13.61-33.433-17.321-50.434-11.133l-54.624-54.624c6.189-16.998 2.479-36.821-11.133-50.433l-23.185-23.174c-18.757-18.757-49.122-18.76-67.882 0L163.914 117.667c-18.715 18.715-18.715 49.167 0 67.883l23.184 23.184c13.613 13.613 33.433 17.326 50.434 11.133l10.342 10.342-56.543 56.52c-22.021-22.02-51.866-19.249-69.498-1.616L14.069 392.908c-18.757 18.757-18.76 49.122 0 67.882l37.163 37.174c18.714 18.714 49.165 18.715 67.882 0l107.773-107.796c17.412-17.41 20.652-47.231-1.616-69.499l56.543-56.519 10.341 10.341c-6.189 16.998-2.479 36.821 11.134 50.434l25.417 25.417c17.484 17.484 45.932 17.485 63.417 0L497.965 244.5c18.713-18.715 18.713-49.167 0-67.882zM85.195 464.043l-.021-.021L48 426.849l107.773-107.795 37.173 37.173L85.195 464.043zm275.219-149.875l-23.184-23.184 14.793-14.793L235.832 160l-14.792 14.792-23.184-23.184L301.465 48l23.184 23.184L307.832 88l116.191 116.191 16.816-16.816 23.184 23.184-103.609 103.609z"
        ></path>
      </svg>
    </StyledContainer>
  );
};

export default GavelLightSVG;
